/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkPackageTypeDtoPage } from '../../models/work-package-type-dto-page';

export interface ListWorkPackageTypes$Params {
  query?: string;
  isActive?: boolean | null;
  isActiveOnNewProjects?: boolean | null;
  excludeIds?: Array<string>;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'name' | '-name' | 'description' | '-description' | 'isActive' | '-isActive' | 'isMilestone' | '-isMilestone' | 'isActiveOnNewProjects' | '-isActiveOnNewProjects' | 'position' | '-position' | 'color' | '-color' | 'icon' | '-icon' | 'workPackageStatuses' | '-workPackageStatuses' | 'defaultWorkPackageStatus' | '-defaultWorkPackageStatus' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listWorkPackageTypes(http: HttpClient, rootUrl: string, params?: ListWorkPackageTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageTypeDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listWorkPackageTypes.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('isActive', params.isActive, {});
    rb.query('isActiveOnNewProjects', params.isActiveOnNewProjects, {});
    rb.query('excludeIds', params.excludeIds, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageTypeDtoPage>;
    })
  );
}

listWorkPackageTypes.PATH = '/v0/workPackageTypes';
